export default __webpack_public_path__ + "static/media/P0inters.34692250.png";